import { useAssistantFacade } from './useAssistantFacade';
import { useMemo } from 'react';
import { usePageLoaderManager } from './usePageLoaderManager';

export function useConversationHistory() {
    const facade = useAssistantFacade();
    const conversationsLoader = useMemo(() => {
        return facade.getConversationsLoader();
    }, [facade]);

  return usePageLoaderManager(conversationsLoader);
}

